export const resolveTourSelector = (target) => `[data-tour="${target}"]`;

const isElementVisible = (el) => {
  // A zero-size box also covers display: none
  const rect = el.getBoundingClientRect();
  if (rect.width === 0 || rect.height === 0) return false;
  const style = window.getComputedStyle(el);
  return style.visibility !== 'hidden' && style.opacity !== '0';
};

// Resolves with the element once it exists and is visible, or with null after `timeout` ms
export const waitForElement = (selector, timeout = 5000) =>
  new Promise((resolve) => {
    const deadline = Date.now() + timeout;
    const check = () => {
      const el = document.querySelector(selector);
      if (el && isElementVisible(el)) return resolve(el);
      if (Date.now() >= deadline) return resolve(null);
      setTimeout(check, 100);
    };
    check();
  });

// Dialogs and temporary drawers only. Dropdowns and tooltips also use .MuiModal-root,
// and docked drawers don't have it, so neither blocks a tour.
export const isAnyModalOpen = () =>
  Array.from(document.querySelectorAll('.MuiDialog-root, .MuiDrawer-root.MuiModal-root')).some(
    (modal) => modal.getAttribute('aria-hidden') !== 'true' && isElementVisible(modal)
  );

export const isGuestUser = () => localStorage.getItem('user_type') === 'GUEST';
